import { Injectable } from '@angular/core';
import { ConfigService } from 'app/app-config.service';

@Injectable()
export class StyleService {
    constructor(private configService: ConfigService) {}

    private updateStyleSheetLink(newUrl: string) {
        const styleElement = document.getElementById('theme-link');
        if (styleElement) {
            styleElement.setAttribute('href', newUrl);
        }
    }

    public initializeApp(): () => Promise<any> {
        return () => {
            return new Promise((resolve, reject) => {
                if (this.configService.getClient.themeConfig) {
                    const colorScheme = this.configService.getClient.themeConfig.colorScheme ?? 'theme-light';
                    const theme = this.configService.getClient.themeConfig.theme ?? 'blue';

                    const newUrl = `assets/layout/styles/theme/${colorScheme}/${theme}/theme.css`;

                    this.updateStyleSheetLink(newUrl);
                }

                resolve(true);
            });
        };
    }
}
